import Axios from "axios";
import { getAuthToken } from "store/authConfig";

import * as actionTypes from "../../actionTypes";

export const chartStart = () => {
  return {
    type: actionTypes.CHART_START
  };
};

export const chartSuccess = (data) => {
  return {
    type: actionTypes.CHART_SUCCESS,
    data: data
  };
};
export const chartFilter = (data) => {
  return {
    type: actionTypes.CHART_FILTER,
    data: data
  }
}
export const chartError = (error) => {
  return {
    type: actionTypes.CHART_ERROR,
    error: error
  };
};

export const Chart = (startMonth, startYear, endMonth, endYear) => {
  return dispatch => {
    dispatch(chartStart());
    getAuthToken();
    Axios.get(
      `/api/apps/chart?startMonth=${startMonth}&startYear=${startYear}&endMonth=${endMonth}&endYear=${endYear}`
    )
      .then(response => {
        dispatch(chartSuccess(response.data));
      })
      .catch(error => {
        dispatch(chartError(error));
      })
  }
}

export const filterChart = (startMonth, startYear, endMonth, endYear, id) => {
  return dispatch => {
    dispatch(chartStart());
    getAuthToken();
    Axios.get(
      `/api/apps/chart/${id}?startMonth=${startMonth}&startYear=${startYear}&endMonth=${endMonth}&endYear=${endYear}`
    )
      .then(response => {
        dispatch(chartFilter(response.data));
      })
      .catch(error => {
        dispatch(chartError(error));
      })
  }
}